import React from 'react';
import PropTypes from 'prop-types';
import ContentBlockWidget from '../Widgets/ContentBlock';

const COMPONENT_TYPES = {
  contentBlock: ContentBlockWidget
};

const NullField = ({ uiSchema, schema }) => {
  // Defaults to ContentBlock widget
  const Widget = COMPONENT_TYPES[(uiSchema && uiSchema['ui:widget']) || 'contentBlock'];
  return (
    <Widget schema={schema} uiSchema={uiSchema} />
  );
};

NullField.propTypes = {
  formData: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  schema: PropTypes.object,
  uiSchema: PropTypes.object
};

export default NullField;



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Renderer/Fields/Null.js